'use strict';
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var app_1 = __importDefault(require("../app"));
var fetchWrapper_1 = __importDefault(require("./fetchWrapper"));
var SubmissionError_1 = __importDefault(require("../error/SubmissionError"));
var ServerError_1 = __importDefault(require("../error/ServerError"));
var ProgressState = /** @class */ (function () {
    function ProgressState() {
    }
    ProgressState.start = function (fetchPromise) {
        // @ts-expect-error
        app_1["default"].$Progress.start();
        ProgressState.poll++;
        fetchPromise
            .then(function () {
            ProgressState.poll--;
        })["catch"](function () {
            ProgressState.poll--;
            ProgressState.hasFailed = true;
        })["finally"](function () {
            if (ProgressState.poll <= 0) {
                ProgressState.finish();
            }
        });
    };
    ProgressState.finish = function () {
        // @ts-expect-error
        app_1["default"].$Progress.finish();
        ProgressState.poll = 0;
        ProgressState.hasFailed = false;
    };
    ProgressState.poll = 0;
    ProgressState.hasFailed = false;
    return ProgressState;
}());
var appFetch = function (request, options) {
    var _this = this;
    if (options === void 0) { options = {}; }
    if ('undefined' === typeof options.headers) {
        options.headers = new Headers();
    }
    else if (!(options.headers instanceof Headers) && typeof options.headers === 'object') {
        options.headers = new Headers(options.headers);
    }
    if (options.method === 'PATCH') {
        options.headers.set('Content-Type', 'application/merge-patch+json');
    }
    var prom = fetchWrapper_1["default"](request, options).then(function (response) { return __awaiter(_this, void 0, void 0, function () {
        var data, json, error, errors;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!response.ok) return [3 /*break*/, 1];
                    return [2 /*return*/, response.json()];
                case 1:
                    if (!(response.status === 403)) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _a.sent();
                    throw {
                        'status': response.status,
                        'payload': data.payload || [],
                    };
                case 3: return [4 /*yield*/, response.json()];
                case 4:
                    json = _a.sent();
                    error = json['hydra:description'] ? json['hydra:description'] : response.statusText;
                    if (!json.violations) {
                        throw new ServerError_1["default"](error);
                    }
                    errors = { _error: error };
                    json.violations.map(function (violation) { return (errors[violation.propertyPath] = violation.message); });
                    throw new SubmissionError_1["default"](errors);
            }
        });
    }); });
    ProgressState.start(prom);
    return prom;
};
exports["default"] = appFetch;
